import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import type {PCMProcessData} from './ExecutionFlowchartPaneTypes';

/**
 * Flowchart config id and root execution flowchart id from PCM process GQL for
 * {@link useExecutionFlowchartDraftStateForProcess}.
 */
export function getFlowchartConfigIdFromProcess(
  processData: PCMProcessData | null | undefined
): string | null {
  if (processData == null || isInaccessible(processData.taskSchemaOrInaccessible)) {
    return null;
  }
  return processData.taskSchemaOrInaccessible.flowchartConfig?.id ?? null;
}

/** Root execution flowchart id from PCM process GQL for {@link useExecutionFlowchartDraftStateForProcess}. */
export function getExecutionFlowchartIdFromProcess(
  processData: PCMProcessData | null | undefined
): string | null {
  if (processData == null || processData.tasks.length === 0) {
    return null;
  }
  return processData.tasks[0].executionFlowchart?.id ?? null;
}

/**
 * Historical flowchart config version id pinned on the process at execution/PCM time.
 * Used to load `availableSchemas` that match the execution flowchart snapshot.
 */
export function getFlowchartConfigVersionIdFromProcess(processData?: PCMProcessData | null): string | null {
  if (processData == null) {
    return null;
  }
  const version = processData.flowchartConfigVersion;
  if (version == null || isInaccessible(version)) {
    return null;
  }
  return version.id;
}
